module.exports = __webpack_public_path__ + "img/Passbild4erBio.eb22eb31.jpg";